import React, { useMemo } from 'react';

import { useAIAnswerContext } from '../../../../ai-answer-context';

import { InlineCitationGroup, type InlineCitationGroupProps } from './inline-citation-group';

export type InlineCitationProps = {
	localId: string;
	text: string;
	color?: string;
};

export const InlineCitation = ({ localId }: InlineCitationProps): React.JSX.Element | null => {
	const { commonAttributes } = useAIAnswerContext();
	const { sources } = commonAttributes;

	const inlineCitationData: InlineCitationGroupProps | undefined = useMemo(() => {
		if (!sources || sources.length === 0) return undefined;

		try {
			const parsedCitationIndices = JSON.parse(localId) as number[];
			const parsedSources = parsedCitationIndices.map((idx) => sources[idx - 1]);
			const citationUrls = parsedSources.map((source) => source.url);
			return {
				citationUrls,
				parsedSources,
			};
		} catch {
			return undefined;
		}
	}, [sources, localId]);

	return !!inlineCitationData ? (
		<InlineCitationGroup parsedSources={inlineCitationData.parsedSources} />
	) : null;
};
